export const MIGRATED_USERNAMES = [
  'CAaligner@cco',
  'Moonsaligner',
  'bassem@premium',
  'Numan@cco',
  'swissaligner@cco',
  'Uprotocol@cco',
  'wesmile@cco',
  'Drglamocanin@cco',

  'artsclinic@cco',
  'usual@cco',
  'Dentalgroup@cco',
  'str8aligners@cco',
  'Whilealigners@cco',
  'Haider ali',
  'Realsmile@cco',
  'dreamaligners@cco',

  'smilezy@cco', 'Routetosmile', 'aop@cco.com',
  
  'sprotocol@cco', 'mabdullah14',
  
  'orthoveer@cco', '2025', '2026', '2026 RO', 'AlignEX', 'diamond clear aligners', 'elitrortholab', 'First clear aligners', 'smile-academy',
  
  'Yosra@cco',
    'DrBentekaya@alignright', 'DrBoukhchina@alignright', 'DrGrouz@alignright',
    'DrJebali@alignright', 'DrLahmer@alignright', 'DrMarzouki@alignright', 'DrMlayeh@alignright', 
    'DrWerimmi@alignright', 'DrZribi@alignright', 'Fakhet@alignright', 'rabeb@alignright',

  'digitalsmiledesign',
    'SHINE ALIGNERS Dr.Asanka', '0007', 'Dentcare',
		'Dr. Akila Alahakoon', 'drsurengomaz', 'Align Dental Care', 'k9dentalhospital',

  'perfectfitOrtho@cco',
   'Brite Dental Partners', 'BriteDentalPartners', 'Brookwood Dental Care', 'Community Dental', 'Elite Dental of Oconomowoc', 
		'Fairway Family Dental Dr. Baumler', 'Fishers Family Smiles', 'Hawthorn Dental St. Charles', 'Lincoln Way Dental Group', 
		'Modern Touch Dental - Glendale', 'Parkside Dental', 'Parkside Dental Dr. Duong', 'Rockford Dental Care', 'Secure Dental', 
		'Secure Dental Hammond', 'Secure Dental Lake Station Dr. Roo, Valley Dental Group', 'West Chester Dental Group',
];

const normalizedMigratedUsernames = new Set(
  MIGRATED_USERNAMES.map((username) => username.trim().toLowerCase())
);

export const isMigratedUser = (username) => {
  if (!username || typeof username !== 'string') {
    return false;
  }

  return normalizedMigratedUsernames.has(username.trim().toLowerCase());
};
